module.exports = __webpack_public_path__ + "static/sport/bgi-form-top.23dbe8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-form-top.png
// module id = 1EWH
// module chunks = 0